import ApiBase from './api_base'
import lodash from 'lodash'

export default class MediaApi {
  // 获得某类资源
  static index(params) {
    return ApiBase.get('/media', lodash.pick(params, ['type', 'tag', 'organization_id', 'public']))
  }

  // 获得某个资源，通过id
  static show(id) {
    return ApiBase.get(`/media/${id}`)
  }

  // 删除某个资源, 通过id
  static destroy(id) {
    return ApiBase.delete(`/media/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/media.js